export default __webpack_public_path__ + "static/1312-2ef249486247988e9980ba8a01a93b62.gif";